import { T } from 'gt-react';

import { AuthErrorMessage } from 'src/pages/(unauthenticated)/AuthErrorMessage';
import { AuthShell } from 'src/pages/(unauthenticated)/AuthShell';

export function InvalidRequest({ error }: { error: Error | string }) {
  return (
    <AuthShell
      title={
        <T context="Gently MCP consent: heading for a malformed request">
          Can't connect this app
        </T>
      }
    >
      <AuthErrorMessage error={error} />
    </AuthShell>
  );
}
